// extracted by mini-css-extract-plugin
export default {"icon":"NkqQK9Ho","shakey":"_6FuRNgcd"};